import React, { useState } from 'react'
import { Modal, Row, Col } from 'react-bootstrap'
import Button from 'react-bootstrap-button-loader'
import * as ajax from '../Utilities/ajax'
import filterFactory from 'react-bootstrap-table2-filter'
import paginationFactory from 'react-bootstrap-table2-paginator'
import BootstrapTable from 'react-bootstrap-table-next'
import Spinner from '../Components/Spinner'

export default function PreviewDescription(props) {

  const [loading, setLoading] = useState(false)
  const [video, setVideo] = useState([])

  const getVideo = async () => {
    setLoading(true)
    if (props.open.val.user) {
      console.log("1")
        await ajax.get("/video/report_videos?user=" + props.open.val.user + `&from=${props.open.val.from}&to=${props.open.val.to}`).then(result =>
            setVideo( result.data.videos )
        ).catch(e => console.log(e))
    } else if (props.open.val.company && props.open.val.key === 1) {
      console.log("2")

        await ajax.get("/video/report_videos_company?company=" + props.open.val.company + `&from=${props.open.val.from}&to=${props.open.val.to}`).then(result =>
            setVideo( result.data.videos )
        ).catch(e => console.log(e))
    } else if (props.open.val.company && props.open.val.key === 2) {
      console.log("3")

        await ajax.get("/video/report_users?company=" + props.open.val.company + `&from=${props.open.val.from}&to=${props.open.val.to}` ).then(result =>
            setVideo( result.data.videos )
        ).catch(e => console.log(e))
    } else if (props.open.val.video && props.open.val.key === 3) {
      console.log("4")

        await ajax.get("/video/report_company?video=" + props.open.val.video + "&from=" + props.open.val.from + "&to=" + props.open.val.to).then(result =>
            setVideo( result.data.videos )
        ).catch(e => console.log(e))
    } else if (props.open.val.video && props.open.val.key === 4) {
      console.log("5")

        await ajax.get("/video/report_user_viewer?video=" + props.open.val.video + "&from=" + props.open.val.from + "&to=" + props.open.val.to).then(result =>
            setVideo( result.data.videos )
        ).catch(e => console.log(e))
    } else if (props.open.val.company && props.open.val.key === 5) {
      console.log("6")

        await ajax.get("/report/title?from=" + props.open.val.from + "&to=" + props.open.val.to + "&libraryId=" + props.open.val.libraryId).then(result =>
            setVideo( result.data.library )
        ).catch(e => console.log(e))
    } else if (props.open.val.libraryId && props.open.val.key === 6) {
      console.log("7")

        await ajax.get("/report/company?from=" + props.open.val.from + "&to=" + props.open.val.to + "&companyId=" + props.open.val.companyId + "&libraryId=" + props.open.val.libraryId ).then(result =>
            setVideo( result.data.companys )
        ).catch(e => console.log(e))
    } else if (props.open.val.libraryId && props.open.val.key === 7) {
      console.log("8")

        await ajax.get("/report/user?from=" + props.open.val.from + "&to=" + props.open.val.to + "&userId=" + props.open.val.userId + "&libraryId=" + props.open.val.libraryId ).then(result =>
            setVideo( result.data.users )
        ).catch(e => console.log(e))
    } else if (props.open.val.libraryId && props.open.val.key === 8) {
      console.log("9")

        await ajax.get("/report/username?from=" + props.open.val.from + "&to=" + props.open.val.to + "&username=" + props.open.val.username + "&libraryId=" + props.open.val.libraryId ).then(result =>
            setVideo( result.data.libraries )
        ).catch(e => console.log(e))
    }

    setLoading(false)
  }

  React.useEffect(() => {
    getVideo()
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [props.open.val])

  const genColumns = () => {
    const columns = []
    if (props.open.val.key === 1) {
        columns.push({ dataField: 'title', text: 'Video Name', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
        columns.push({ dataField: 'section', text: 'Video Section', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
        columns.push({ dataField: 'createdAt', text: 'Create Time', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
    } else if (props.open.val.key === 2) {
        columns.push({ dataField: 'username', text: 'Username', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
        columns.push({ dataField: 'position', text: 'Position', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
        columns.push({ dataField: 'firstName', text: 'First Name', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
        columns.push({ dataField: 'lastName', text: 'Last Name', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
    } else if (props.open.val.key === 3) {
        columns.push({ dataField: 'company', text: 'Company Name', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
        columns.push({ dataField: 'view', text: 'View Number', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
        columns.push({ dataField: 'viewTime', text: 'View Time', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
    } else if (props.open.val.key === 4) {
        columns.push({ dataField: 'username', text: 'Username', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
        columns.push({ dataField: 'view', text: 'View Number', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
        columns.push({ dataField: 'viewTime', text: 'View Time', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
    } else if (props.open.val.key === 5) {
        columns.push({ dataField: 'title', text: 'Title', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
        columns.push({ dataField: 'target', text: 'Target (THB)', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
        columns.push({ dataField: 'sector', text: 'Sector', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
    } else if (props.open.val.key === 6) {
        columns.push({ dataField: 'company', text: 'Company Name', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
        columns.push({ dataField: 'view', text: 'View Number', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
    } else if (props.open.val.key === 7) {
        columns.push({ dataField: 'username', text: 'Username', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
        columns.push({ dataField: 'view', text: 'View Number', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
    } else if (props.open.val.key === 8) {
        columns.push({ dataField: 'title', text: 'Title', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
        columns.push({ dataField: 'target', text: 'Target (THB)', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
        columns.push({ dataField: 'sector', text: 'Sector', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
    } else {
        columns.push({ dataField: 'username', text: 'Username', headerStyle: { width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true,  })
    }
    
    return columns
  }
  
  return (
    <Modal className="modal-dialog-report" show={props.open.show}>
      <Modal.Header>
        <Modal.Title>{props.open.title || ""}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
            <Row style={{ marginTop: 10 }}>
              <Col>
                {loading ? <Spinner /> : <BootstrapTable
                  keyField='id'
                  wrapperClasses="table-responsive"
                  striped hover bootstrap4
                  data={video}
                  columns={genColumns()}
                  filter={filterFactory()}
                  pagination={paginationFactory({
                    sizePerPage: 10,
                    hidePageListOnlyOnePage: true,
                    hideSizePerPage: true,
                  })}
                />}
              </Col>
            </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button bsStyle="default" onClick={() => props.callback()}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  )
}